import { flattenDeep } from 'lodash';
import { Permission, UserData } from '../components/UserDataContext/types';

type AccumulatorType = (string | AccumulatorType)[];

const getPermissions = (permissions: Permission[]) =>
  permissions.reduce((accumulator: AccumulatorType, currentValue) => {
    accumulator.push(currentValue.name);
    if (currentValue.subPermissions.length > 0) {
      const subPermissions = getPermissions(currentValue.subPermissions);
      accumulator.push(subPermissions);
    }
    return accumulator;
  }, []);

export const getRoles = (userData: UserData | null) => {
  if (!userData) {
    return [];
  }
  return flattenDeep(getPermissions(userData.authorities));
};
